// projectsData.js
export const projects = [ 
    {
        index: 1,
        image: require('./../../images/projects/szczecin/front.png'),
        alt: 'Projekt skateparku w Szczecinie - konstrukcja modułowa drewniana, zaprojektowana i zrealizowana w listopadzie 2023 dla inwestora prywatnego. Skatepark idealny do jazdy na deskorolce, BMX, hulajnogach oraz rolkach.',
        projectImages: [
            require('./../../images/projects/szczecin/1.jpg'),
            require('./../../images/projects/szczecin/2.jpg'),
            require('./../../images/projects/szczecin/3.jpg'),
            require('./../../images/projects/szczecin/4.jpg'),
            require('./../../images/projects/szczecin/6.jpg'),
        ],
        title: 'Szczecin',
        date: 'Listopad 2023',
        client: 'inwestor prywatny',
        technology: 'konstrukcja modułowa, drewniana',
        location: 'Szczecin',
        filter: 'cat-1',
        description: '',
        logo: require('./../../images/testimonials/lebork.png'),
        videoImg: require('./../../images/projects/szczecin/videoImg.png'),
        video: require('./../../images/projects/szczecin/video.mp4'),
        link: '/projekt-szczecin'
    },
    {
        index: 2,
        image: require('./../../images/projects/krzeszowice/front.png'),
        alt: 'Skatepark w Krzeszowicach - konstrukcja modułowa drewniana, zaprojektowana na Igrzyska Europejskie Kraków Małopolska w czerwcu 2023. Przestrzeń rekreacyjna idealna do jazdy na deskorolce, BMX, hulajnogach i rolkach.',
        projectImages: [
            require('./../../images/projects/krzeszowice/1.jpg'),
            require('./../../images/projects/krzeszowice/2.jpg'),
            require('./../../images/projects/krzeszowice/3.jpg'),
            require('./../../images/projects/krzeszowice/4.jpg'),
            require('./../../images/projects/krzeszowice/5.jpg'),
            require('./../../images/projects/krzeszowice/6.jpg')
        ],
        title: 'Krzeszowice',
        date: 'Czerwiec 2023',
        client: 'event',
        technology: 'konstrukcja modułowa, drewno',
        location: 'Krzeszowice, Igrzyska Europejskie Kraków Małopolska',
        filter: 'cat-3',
        description: '',
        // logo: require('./../../images/testimonials/krzeszowice.png'),
        videoImg: require('./../../images/projects/krzeszowice/videoImg.png'),
        video: require('./../../images/projects/krzeszowice/video.m4v'),
        link: '/projekt-krzeszowice'
    },
    {
        index: 3,
        image: require('./../../images/projects/lebork/front.png'),
        alt: 'Nowoczesny skatepark w Lęborku - modułowa konstrukcja z drewno-kompozytu. Projekt zrealizowany w styczniu 2024 na zlecenie gminy Lębork, lokalizacja: ul. 8 Maja. Idealne miejsce do jazdy na deskorolce, BMX, hulajnogach oraz rolkach.',
        projectImages: [
            require('./../../images/projects/lebork/lebork2.png'),
            require('./../../images/projects/lebork/lebork3.png'),
            require('./../../images/projects/lebork/leobork1.jpg')
        ],
        title: 'Lębork',
        date: 'Styczeń 2024',
        client: 'gmina Lębork',
        technology: 'konstrukcja modułowa, drewno-kompozyt',
        location: 'ul. 8 Maja, Lębork',
        filter: 'cat-2',
        description: '',
        logo: require('./../../images/testimonials/lebork.png'),
        videoImg: require('./../../images/projects/lebork/videoImg.png'),
        video: require('./../../images/projects/lebork/video.MP4'),
        link: '/projekt-lebork'
    },
    {
        index: 4,
        image: require('./../../images/projects/jedlicze/front.png'),
        alt: 'Skatepark w Jedliczach - modułowa konstrukcja z drewno-kompozytu. Zrealizowany w styczniu 2024 na zlecenie gminy Jedlicze, lokalizacja: ul. 8 Maja. Przestrzeń rekreacyjna idealna do jazdy na deskorolce, BMX, hulajnogach i rolkach.',
        projectImages: [
            require('./../../images/projects/jedlicze/1.jpg'),
            require('./../../images/projects/jedlicze/2.jpg'),
            require('./../../images/projects/jedlicze/3.jpg'),
            require('./../../images/projects/jedlicze/4.jpg'),
            require('./../../images/projects/jedlicze/5.jpg')
        ],
        title: 'Jedlicze',
        date: 'Styczeń 2024',
        client: 'gmina Jedlicze',
        technology: 'konstrukcja modułowa, drewno-kompozyt',
        location: 'ul. 8 Maja, Jedlicze',
        filter: 'cat-2',
        description: '',
        logo: require('./../../images/testimonials/jedlicze.png'),
        videoImg: require('./../../images/projects/jedlicze/videoImg.jpg'),
        video: require('./../../images/projects/lebork/video.MP4'),
        link: '/projekt-jedlicze'
    }
];

export const filters = [
    { label: "Samorządy", filter: ".cat-1" },
    { label: "Inwestorzy Prywatni", filter: ".cat-2" },
    { label: "Eventy", filter: ".cat-3" },
];

